// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"30887":"f66d4429738d4ece","44258":"0d3cdbf832c0640c"}[chunkId] + ".css";
};